import type { GetDevLinksResponse } from "@/backend/natsstubs/almsync/jira/models";

import { retrieveBackendSession } from "../impl/backendSessionCache";

export type DevLink = GetDevLinksResponse["devLinks"][number];
export type DevLinkStatus = DevLink["devStatus"];

export async function fetchDevLinks(issueKey: string): Promise<DevLink[]> {
  const session = retrieveBackendSession();
  if (!session) {
    return [];
  }
  return await session.getDevLinks(issueKey);
}
